export default [
  {
    key: '1', name: '客户管理', icon: 'usergroup-add', submenus: [
      { key: '/custom', name: '客户列表'},
      { key: '/custom-asset', name: '客户资金列表'},
      { key: '/custom-trade', name: '客户交易记录'},
    ]
  },
  {
    key: '2', name: '会员管理', icon: 'team', submenus: [
      { key: '/member', name: '会员列表'},
      { key: '/member-type', name: '会员类型'},
      { key: '/member-buyLog', name: '会员充值记录'},
    ]
  },
  {
    key: '3', name: '股票池管理', icon: 'bank', submenus: [
      { key: '/symbols-cjdx', name: '超级短线' },
      { key: '/symbols-yzqmx', name: '游资全明星' },
      { key: '/symbols-smqmx', name: '私募全明星' },
    ]
  },
  {
    key: '4', name: '系统管理', icon: 'setting', submenus: [
      { key: '/account', name: '员工账号' },
    ]
  },
]